import { createSlice } from "@reduxjs/toolkit";
import { handleLogin, handleLogout } from "@features/auth/action";
import { LoginStateI } from "@features/auth/types";

const userToken = localStorage.getItem("userToken")
  ? localStorage.getItem("userToken")
  : null;

const userSettings = localStorage.getItem("userSettings")
  ? JSON.parse(localStorage.getItem("userSettings")!)
  : {};

const userLogonId = localStorage.getItem("userLogonId") ?? null;

const initialState: LoginStateI = {
  loading: false,
  userInfo: null,
  userToken: userToken,
  userLogonId: userLogonId,
  userSettings: userSettings,
  error: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveUser: (state, action) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(handleLogin.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(handleLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.userToken = action.payload?.sessionToken;
      state.userSettings = action.payload;
      state.userLogonId = action.meta.arg.userLogonId;
    });
    builder.addCase(handleLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(handleLogout.fulfilled, (state) => {
      state.userToken = null;
      state.userLogonId = null;
    });
  },
});

export default authSlice.reducer;
